import { Title } from "@mantine/core";
import type { ComponentProps } from "react";

type HugeTitleProps = ComponentProps<typeof Title>;

export function HugeTitle({ children, order = 2, ...props }: HugeTitleProps) {
  return (
    <Title c="#014d40" order={order} style={{ fontSize: "3.2rem" }} {...props}>
      {children}
    </Title>
  );
}
